import { Button, Input, Label, Modal, ModalBody, ModalHeader } from "reactstrap";
import { useEffect, useState } from "react";
import Select from "react-select";
import { useSelectStyles } from "Components/Hooks/useSelectStyles";
import { useDispatch } from "react-redux";
import { exportRequest } from "store/export/action";

const FILE_FORMATS = [
    { value: "xlsx", label: "Excel (.xlsx)" },
    { value: "csv", label: "CSV (.csv)" },
];

const ExportModal = ({ model, show, onCloseClick, props, viewDetails, viewId }: any) => {
    const dispatch = useDispatch<any>();
    const customStyles = useSelectStyles();
    const [exportName, setExportName] = useState<string>('');
    const [fileInfo, setFileInfo] = useState();

    useEffect(() => {
        // Initialize or reset state when modal opens
        if (viewDetails) {
            setExportName(viewDetails?.viewName);
        }
    }, [viewDetails]);

    const handleExportClick = () => {
  if (!exportName || !fileInfo) return;

  const params = {
    viewId: viewId,
    fileName: exportName,
    fileType: fileInfo,
  };

  dispatch(exportRequest(
    model,
    params
  ));
};

    return (
        <Modal backdrop="static" isOpen={show} toggle={onCloseClick} centered={true}>
            <ModalHeader className="p-3 offcanvas-header-dark d-flex flex-row justify-content-between align-items-center bg-primary" toggle={onCloseClick}>
                <span className="text-light">{props.t("Export")}</span>
            </ModalHeader>
            <ModalBody className="p-4">
                <div className="mb-4">
                    <p className="text-muted small mb-1">
                        The exported file will be emailed to <strong>{viewDetails?.userEmail}</strong> and posted in your{" "}
                        Notifications.
                    </p>
                    {/* <p className="text-muted small">
                        View this and past exports in{" "}
                        <a href="#" className="text-decoration-underline">Export Audit</a>.
                    </p> */}
                </div>
                <div className="mb-4">
                    <Label className="form-label" for="exportName">
                        Export Name <span className="text-danger">*</span>
                    </Label>
                    <Input
                        id="exportName"
                        placeholder="Enter a name for the export"
                        value={exportName}
                        onChange={(e) => setExportName(e.target.value)}
                    />
                    <small className="text-muted">
                        This name will help you identify the exported file later.
                    </small>
                </div>

                <div className="mb-4">
                    <Label className="form-label" for="fileFormat">
                        File Format <span className="text-danger">*</span>
                    </Label>
                    <Select
                        inputId="fileFormat"
                        styles={customStyles}
                        options={FILE_FORMATS}
                        value={fileInfo ? FILE_FORMATS.find(opt => opt.value === fileInfo) : null}
                        onChange={(option: any) => setFileInfo(option.value)}
                        placeholder="Select a file format (e.g., CSV, XLSX)"
                    />
                    <small className="text-muted">
                        Choose the format in which the data should be exported.
                    </small>
                </div>

                <div className="d-flex justify-content-between mt-4">
                    <Button
                        color="danger"
                        onClick={onCloseClick}
                    >
                        {props.t("Cancel")}
                    </Button>

                    <Button
                        color="primary"
                        onClick={() => {
                            handleExportClick()
                            onCloseClick();
                        }}
                        disabled={!exportName || !fileInfo}
                    >
                        {props.t("Export")}
                    </Button>
                </div>
            </ModalBody>
        </Modal>

    ) as unknown as JSX.Element;
};

export default ExportModal;